import { Suspense } from 'react';

import { isWorkshopParentFrontend } from '@/config';
import { LoadingIndicator } from '@/features/app/LoadingIndicator';
import BatterySidebar from '@/features/battery/customer/BatterySidebar';
import BatteryOverview from '@/features/battery/workshop/BatteryOverview';

const AssetBatteryData = () => {
    const isWorkshopParentFE = isWorkshopParentFrontend();

    return (
        <div className={'overflow-hidden display-flex flex-column'}>
            <Suspense fallback={<LoadingIndicator />}>
                {isWorkshopParentFE && <BatteryOverview />}
                {!isWorkshopParentFE && <BatterySidebar />}
            </Suspense>
        </div>
    );
};

export default AssetBatteryData;
